export default __webpack_public_path__ + "static/media/Integrated Corporate Governance.9c35bd19.pdf";